import React, { useState, useEffect } from 'react';
import { useCart } from "react-use-cart";

const Shopping = () => {
    const { cartTotal, metadata, updateCartMetadata } = useCart();
    const [open, setOpen] = useState((metadata !== undefined && metadata.open) || false);
    const [loading, setLoading] = useState(true);

    const {
        // isEmpty,
        totalUniqueItems,
        items,
        updateItemQuantity,
        removeItem,
    } = useCart();

    useEffect(() => { setOpen(true) }, [items])
    useEffect(() => {
        metadata && metadata.open ? setOpen(true) : setOpen(false)
        console.log('metadata.token', metadata)
    }, [metadata])

    
  const amount = cartTotal;

  useEffect(() => {
    
    const postData = async () => {
      try {

        const response = await fetch('https://api-trbk.marturica.workers.dev/api/trbk', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            amount: amount > 0 ? amount : '10',
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json()
        
        setLoading(false);
        updateCartMetadata({ token: data.token , url:data.url})
        

        //updateCartMetadata({url:data.url})
        
      } catch (err) {
        //setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {

      }
    }
    postData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])






    return (
        !loading && 
        <form action={metadata !== undefined && metadata.url} method="post" >
            <input name="token_ws" type="hidden" value={metadata !== undefined && metadata.token} />

            {/* <div class={`relative ${open?'':'hidden'} `} aria-labelledby="slide-over-title" role="dialog" aria-modal="true"> */}
            {/* <!--
        Background backdrop, show/hide based on slide-over state.
        Entering: "ease-in-out duration-500"
        From: "opacity-0"
        To: "opacity-100"
        Leaving: "ease-in-out duration-500"
        From: "opacity-100"
        To: "opacity-0"
  --> */}
            {/* <div class={`fixed inset-0 bg-gray-500/75 transition-opacity`} aria-hidden="true"></div> */}

            {/* <div class="fixed  inset-0 overflow-hidden"> */}

            <div class="absolute inset-0 overflow-hidden ">
                <div class={`z-40 pointer-events-none fixed inset-y-0  flex max-w-full pl-10  pt-20 ${open ? 'right-0' : 'right-full'}`}>
                    {/* <!--
          Slide-over panel, show/hide based on slide-over state.

          Entering: "transform transition ease-in-out duration-500 sm:duration-700"
            From: "translate-x-full"
            To: "translate-x-0"
          Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
            From: "translate-x-0"
            To: "translate-x-full"
        --> */}
                    <div class="pointer-events-auto w-screen max-w-md">
                        <div class="flex h-full flex-col  bg-white shadow-xl">
                            <div class="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
                                <div class="flex items-start justify-between">
                                    <h2 class="text-lg font-medium text-gray-900" id="slide-over-title">Carro Compras ({totalUniqueItems})</h2>
                                    <div class="ml-3 flex h-7 items-center">
                                        <button onClick={() => updateCartMetadata({ open: false })} type="button" class="relative -m-2 p-2 text-gray-400 hover:text-gray-500">
                                            <span class="absolute -inset-0.5"></span>
                                            <span class="sr-only">Close panel</span>
                                            <svg class="size-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>

                                <div class="mt-8">
                                    <div class="flow-root">
                                        <ul class="-my-6 divide-y divide-gray-200">
                                            {items.map((t) =>
                                                <li key={t.id} class="flex py-6">
                                                    <div class="size-24 shrink-0 overflow-hidden rounded-md border border-gray-200">
                                                        <img src={t.img} alt={t.name} class="size-full object-cover" />
                                                    </div>

                                                    <div class="ml-4 flex flex-1 flex-col">
                                                        <div>
                                                            <div class="flex justify-between text-base font-medium text-gray-900">
                                                                <h3>
                                                                    <a href=" ">{t.name}</a>
                                                                </h3>
                                                                <p class="ml-4">{t.price * t.quantity}</p>
                                                            </div>
                                                            {/* <p class="mt-1 text-sm text-gray-500">{t.desc}</p> */}
                                                        </div>
                                                        <div class="flex flex-1 items-end justify-between text-sm">
                                                            <p class="text-gray-500">Cantidad
                                                                <label for="counter-input" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Choose quantity:</label>
                                                                <div class="relative flex items-center">
                                                                    <button disabled={t.quantity === 1 ? true : false} onClick={() => updateItemQuantity(t.id, (t.quantity ?? 0) - 1)} type="button" id="decrement-button" data-input-counter-decrement="counter-input" class="shrink-0 bg-gray-100  hover:bg-gray-200 inline-flex items-center justify-center border border-gray-300 rounded-md h-5 w-5 focus:ring-gray-100 focus:ring-2 focus:outline-none">
                                                                        <svg class="w-2.5 h-2.5 text-gray-900 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 2">
                                                                            <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h16" />
                                                                        </svg>
                                                                    </button>
                                                                    <input type="text" id="counter-input" value={t.quantity} data-input-counter class="shrink-0 text-gray-900 border-0 bg-transparent text-sm font-normal focus:outline-none focus:ring-0 max-w-[2.5rem] text-center" placeholder="" required />
                                                                    <button type="button" onClick={() => updateItemQuantity(t.id, (t.quantity ?? 0) + 1)} id="increment-button" data-input-counter-increment="counter-input" class="shrink-0 bg-gray-100 hover:bg-gray-200 inline-flex items-center justify-center border border-gray-300 rounded-md h-5 w-5 focus:ring-gray-100 dark:focus:ring-gray-700 focus:ring-2 focus:outline-none">
                                                                        <svg class="w-2.5 h-2.5 text-gray-900 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                                                                            <path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1v16M1 9h16" />
                                                                        </svg>
                                                                    </button>
                                                                </div>
                                                                {/* <button
                                                                    className='rounded-full'
                                                                    onClick={() => updateItemQuantity(t.id, (t.quantity ?? 0) - 1)}
                                                                >
                                                                    -
                                                                </button>
                                                                {t.quantity}
                                                                <button
                                                                    className='rounded-full'
                                                                    onClick={() => updateItemQuantity(t.id, (t.quantity ?? 0) + 1)}
                                                                >
                                                                    +
                                                                </button> */}
                                                            </p>

                                                            <div class="flex">
                                                                <button type="button" onClick={() => removeItem(t.id)} class="font-medium text-indigo-600 hover:text-indigo-500">Remove</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            )}
                                            {/* <li class="flex py-6">
                                                        <div class="size-24 shrink-0 overflow-hidden rounded-md border border-gray-200">
                                                            <img src="https://tailwindcss.com/plus-assets/img/ecommerce-images/shopping-cart-page-04-product-01.jpg" alt="Salmon orange fabric pouch with match zipper, gray zipper pull, and adjustable hip belt." class="size-full object-cover" />
                                                        </div>

                                                        <div class="ml-4 flex flex-1 flex-col">
                                                            <div>
                                                                <div class="flex justify-between text-base font-medium text-gray-900">
                                                                    <h3>
                                                                        <a href="#">Throwback Hip Bag</a>
                                                                    </h3>
                                                                    <p class="ml-4">$90.00</p>
                                                                </div>
                                                                <p class="mt-1 text-sm text-gray-500">Salmon</p>
                                                            </div>
                                                            <div class="flex flex-1 items-end justify-between text-sm">
                                                                <p class="text-gray-500">Qty 1</p>

                                                                <div class="flex">
                                                                    <button type="button" class="font-medium text-indigo-600 hover:text-indigo-500">Remove</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li class="flex py-6">
                                                        <div class="size-24 shrink-0 overflow-hidden rounded-md border border-gray-200">
                                                            <img src="https://tailwindcss.com/plus-assets/img/ecommerce-images/shopping-cart-page-04-product-02.jpg" alt="Front of satchel with blue canvas body, black straps and handle, drawstring top, and front zipper pouch." class="size-full object-cover" />
                                                        </div>

                                                        <div class="ml-4 flex flex-1 flex-col">
                                                            <div>
                                                                <div class="flex justify-between text-base font-medium text-gray-900">
                                                                    <h3>
                                                                        <a href="#">Medium Stuff Satchel</a>
                                                                    </h3>
                                                                    <p class="ml-4">$32.00</p>
                                                                </div>
                                                                <p class="mt-1 text-sm text-gray-500">Blue</p>
                                                            </div>
                                                            <div class="flex flex-1 items-end justify-between text-sm">
                                                                <p class="text-gray-500">Qty 1</p>

                                                                <div class="flex">
                                                                    <button type="button" class="font-medium text-indigo-600 hover:text-indigo-500">Remove</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li> */}

                                            {/* <!-- More products... --> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="border-t border-gray-200 px-4 py-6 sm:px-6">
                                <div class="flex justify-between text-base font-medium text-gray-900">
                                    <p>Subtotal</p>
                                    <p>{cartTotal}</p>
                                </div>

                                <div class="flex justify-between text-base font-medium text-gray-900">
                                    <p>IVA</p>
                                    <p>{cartTotal * 0.19}</p>
                                </div>
                                <div class="flex justify-between text-base font-medium text-gray-900">
                                    <p>Envio</p>
                                    <p>{totalUniqueItems > 0 ? cartTotal > 120000 ? 10000 : 5000 : 0}</p>
                                </div>
                                <p class="mt-0.5 text-sm text-gray-500">Solo envíos dentro de Santiago.</p>
                                <div class="flex justify-between text-base font-medium text-gray-900">
                                    <p>Total</p>
                                    <p>{cartTotal * 1.19 + (totalUniqueItems > 0 ? 5000 : 0)}</p>
                                </div>
                                <div class="mt-6">
                                    <button type="submit" class="flex items-center w-full justify-center rounded-md border border-transparent bg-indigo-600 px-6 py-3 text-base font-medium text-white shadow-xs hover:bg-indigo-700">Pagar</button>
                                </div>
                                <div class="mt-6 flex justify-center text-center text-sm text-gray-500">

                                    <button onClick={() => setOpen(false)} type="button" class="font-medium text-indigo-600 hover:text-indigo-500">
                                        Cerrar
                                        {/* <span aria-hidden="true"> &rarr;</span> */}
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            {/* </div> */}
            {/* </div> */}
        </form>


    )
}

export default Shopping;
